import { BILLER_ACCOUNT_TYPE } from '../constants/tealiumData'

export const getCustomerTypeCode = () => {
  const DEFAULT_CUSTOMER_TYPE = 'customer type r'
  if (sessionStorage.getItem('customerType')) {
    return `customer type ${sessionStorage
      .getItem('customerType')
      .toLowerCase()}`
  }
  return `${DEFAULT_CUSTOMER_TYPE}`
}

export const getBillerType = (isPayeeInternal, eBillID) => {
  if (isPayeeInternal) return BILLER_ACCOUNT_TYPE.INTERNAL
  return eBillID
    ? BILLER_ACCOUNT_TYPE.EXTERNAL_EBILLER
    : BILLER_ACCOUNT_TYPE.EXTERNAL
}

export const getAccountType = (isPayeeInternal, eBillID, payee) => {
  if (!isPayeeInternal)
    return eBillID
      ? BILLER_ACCOUNT_TYPE.EXTERNAL_EBILLER
      : BILLER_ACCOUNT_TYPE.EXTERNAL
  return `${payee?.payeeAccountInfo?.[0]?.productCode}:${payee?.payeeAccountInfo?.[0]?.subProductCode}`
}
